import axiosInstance from 'src/utils/axios';
import { EmbeddedReport, EmbedTokenResult, ExportFileRequest } from 'src/models/reports';
import { AxiosResponse } from 'axios';
import { ReportRole } from 'src/models/report-roles';

const reportService = {
  getReports: async (): Promise<EmbeddedReport[]> => {
    try {
      const response = await axiosInstance.get('/api/reports', {});
      return response.data;
    } catch (error) {
      console.error('Error logging in user:', error);
      throw error;
    }
  },

  getEmbedToken: async (reportId: string): Promise<EmbedTokenResult> => {
    try {
      const response = await axiosInstance.get(`/api/reports/${reportId}/token`);
      return response.data;
    } catch (error) {
      console.error('Error fetching embed token:', error);
      throw error;
    }
  },

  exportReport: async (exportRequest: ExportFileRequest): Promise<Blob> => {
    try {
      const response = await axiosInstance.post(`/api/reports/${exportRequest.ReportId}/export`, exportRequest, {
        responseType: 'blob',
      });
      return response.data;
    } catch (error) {
      console.error('Error exporting report:', error);
      throw error;
    }
  },

  getReportRoles: async (): Promise<ReportRole[]> => {
    try {
      const response = await axiosInstance.get<ReportRole[]>(`/api/reports/roles`);
      return response.data;
    }
    catch (error) {
      console.error('Error exporting report:', error);
      throw error;
    }
  },


};

export default reportService;